module.exports = __webpack_public_path__ + "static/media/idol_think.060cb350.svg";